import { CommentIcon } from '#app/components/icons'

export default {
	name: 'Comment',
	slug: 'comment',
	description: 'Whatever you want to say about the artwork',
	version: '1.0.0',
	icon: <CommentIcon />,
	fields: [
		{
			name: 'Title',
			slug: 'title',
			required: false,
			type: 'text',
			placeholder: 'The title of the comment',
		},
		{
			name: 'Description',
			slug: 'description',
			required: true,
			type: 'text',
			placeholder: 'The description of the comment',
		},
	],
	info: 'https://atomicform.faq',
}
